import './global.js';
import {compose, v$} from './includes/helpers.js';


const parent = document.querySelector('.reports-main-container');
const filterSelect = document.querySelector('.reports-main-filter-select select');
const filterBtns = v$('.reports-main-filter .btn[data-filter]');

const renderReportData = reportData => {
    reportData.forEach(obj => {
        let div = `<div class="reports-main-item ${(obj.type === 'annualy') ? 'red' :
            (obj.type === 'special') ? 'blue' :
                (obj.type === 'quarterly') ? 'gray' :
                    (obj.type === 'other') ? 'orange' : ''
            }">
                        <span>${obj.title}</span>
                        <span>${obj.fileType}</span>
                        <a href="${obj.link}" download>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15.7">
                              <path  d="M18 12.1v2.5c0 .3-.1.5-.3.7-.2.2-.4.3-.7.3H1c-.3 0-.5-.1-.7-.3-.2-.1-.3-.4-.3-.7v-2.5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h5l1.5 1.5c.5.4.9.6 1.5.6s1.1-.2 1.5-.6l1.5-1.5h5c.3 0 .5.1.7.3.2.2.3.4.3.7zM14.5 6c.1.3.1.5-.2.8l-4.8 4.8c-.1.1-.3.2-.5.2s-.4-.1-.5-.2L3.7 6.7c-.3-.2-.3-.4-.2-.7.1-.3.3-.4.6-.4h2.8V.7c0-.2.1-.3.2-.5.2-.1.3-.2.5-.2h2.8c.2 0 .3.1.5.2.1.1.2.3.2.5v4.8h2.8c.3 0 .5.2.6.5z"/>
                            </svg>
                        <span>${obj.linkCont}</span>
                        </a>
                    </div>`;
        parent.innerHTML += div;
    });

}
let reportData = process.env.NODE_ENV === 'development' ? null : window.reportsData;
if (process.env.NODE_ENV === 'development') {
    fetch('../data/reportsData.json')
        .then(res => res.json())
        .catch(err => console.log(err))
        .then(response => {
            reportData = Object.values(response);
            renderReportData(reportData);
        })
} else {
    reportData = donCredit;
    renderReportData(reportData);
}


const changeActive = type => {
    filterBtns.forEach(btn => {
        btn.classList.remove('active');
        //
        // btn.className = btn.getAttribute('data-filter') === type ? 'btn active' : 'btn';
        //
        let thisBtnType = btn.getAttribute('data-filter');
        if (thisBtnType == type) {
            btn.classList.add('active');
        }
    });

    return type;
}
const changeSelect = type => {
    // filterSelect.value = type;
    let options = v$('.select-options li', filterSelect.parentNode),
        selectView = filterSelect.nextElementSibling,
        optionText = null;
    options.forEach(item => {
        optionText = item.getAttribute('rel') === type ? item.innerText : optionText;
    })
    selectView.innerText = optionText;
    return type;
}
const filterItems = type => {

    return reportData.filter(item => {
        if (type == 'all') {
            return true;
        } else {
            return type == item.type;
        }
    });
}
const clearParent = arr => {
    parent.innerHTML = '';
    return arr;
}


const filterReports = compose(
    renderReportData,
    clearParent,
    filterItems,
    changeSelect,
    changeActive
);


filterBtns.forEach(btn => {
    btn.addEventListener('click', e => {
        let type = e.target.getAttribute('data-filter');
        filterReports(type);
    });
});
filterSelect.addEventListener('change', e => {
    let value = e.target.value;
    filterReports(value);
});

/* tabs */
(function () {
    $('.common-tabs-block').each(function () {
        $(this).find('.tab a').on('click', function (e) {
            e.preventDefault();
            if ($(this).attr('id') === 'don-credit') {
                reportData = donCredit;
            } else {
                reportData = BLJ;
            }
            $('.reports-main-container').html('');
            changeSelect('all');
            changeActive('all');
            renderReportData(reportData);

            var item = $(this).closest('.tab'),
                itemPosition = item.data('tab');

            if (itemPosition !== $(this).find('.active').closest('.tab').data('tab')) {
                $(this).closest('.common-tabs-block').find('.tab').removeClass('active');
                $(this).closest('.tab').addClass('active');
            }
        });
    });
}());








